export default {
  getAccountStatusTrendList: ({ accountStatusTrendList }) => {
    return accountStatusTrendList;
  },
  getAccountStatusDiffList: ({ accountStatusDiffList }) => {
    return accountStatusDiffList;
  },
  getAccountStatusCspList: ({ accountStatusCspList }) => {
    return accountStatusCspList;
  },
}



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/status/accountStatusGetter.js